import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { movies, articles } from '@/mocks/movies';

const detailPosterImages: Record<string, string> = {
  'movie-interstellar': 'https://readdy.ai/api/search-image?query=Interstellar%20Chinese%20movie%20poster%20design%20dramatic%20cinematic%20film%20poster%20dark%20background%20warm%20golden%20accents%20professional%20high%20quality%20artwork&width=600&height=900&seq=detail-interstellar&orientation=portrait',
  'movie-wandering-earth': 'https://readdy.ai/api/search-image?query=The%20Wandering%20Earth%202%20Chinese%20sci%20fi%20movie%20poster%20design%20cinematic%20film%20poster%20dark%20background%20professional%20high%20quality%20artwork&width=600&height=900&seq=detail-wandering-earth&orientation=portrait',
  'movie-hi-mom': 'https://readdy.ai/api/search-image?query=Hi%20Mom%20Chinese%20comedy%20drama%20movie%20poster%20design%20warm%20nostalgic%20cinematic%20film%20poster%20dark%20background%20professional%20artwork&width=600&height=900&seq=detail-hi-mom&orientation=portrait',
  'movie-changjin': 'https://readdy.ai/api/search-image?query=The%20Battle%20at%20Lake%20Changjin%20Chinese%20war%20drama%20movie%20poster%20design%20cinematic%20film%20poster%20dark%20background%20professional%20artwork&width=600&height=900&seq=detail-changjin&orientation=portrait',
  'movie-nezha': 'https://readdy.ai/api/search-image?query=Nezha%20Chinese%20animated%20movie%20poster%20design%20cinematic%20film%20poster%20dark%20background%20warm%20golden%20accents%20professional%20artwork&width=600&height=900&seq=detail-nezha&orientation=portrait',
  'movie-fengshen': 'https://readdy.ai/api/search-image?query=Creation%20of%20the%20Gods%20Chinese%20fantasy%20movie%20poster%20design%20cinematic%20film%20poster%20dark%20background%20professional%20artwork&width=600&height=900&seq=detail-fengshen&orientation=portrait',
  'movie-lost-her': 'https://readdy.ai/api/search-image?query=Lost%20in%20the%20Stars%20Chinese%20mystery%20thriller%20movie%20poster%20design%20cinematic%20film%20poster%20dark%20background%20professional%20artwork&width=600&height=900&seq=detail-lost-her&orientation=portrait',
  'tv-zhenhuan': 'https://readdy.ai/api/search-image?query=Empresses%20in%20the%20Palace%20Chinese%20period%20drama%20poster%20design%20elegant%20cinematic%20film%20poster%20dark%20background%20professional%20artwork&width=600&height=900&seq=detail-zhenhuan&orientation=portrait',
  'tv-kuangbiao': 'https://readdy.ai/api/search-image?query=The%20Knockout%20Chinese%20crime%20drama%20TV%20series%20poster%20design%20cinematic%20film%20poster%20dark%20background%20professional%20artwork&width=600&height=900&seq=detail-kuangbiao&orientation=portrait',
  'movie-farewell': 'https://readdy.ai/api/search-image?query=Farewell%20My%20Concubine%20Chinese%20classic%20drama%20movie%20poster%20design%20cinematic%20film%20poster%20dark%20background%20professional%20artwork&width=600&height=900&seq=detail-farewell&orientation=portrait',
  'movie-fast10': 'https://readdy.ai/api/search-image?query=Fast%20and%20Furious%2010%20action%20movie%20poster%20design%20cinematic%20film%20poster%20dark%20background%20professional%20artwork&width=600&height=900&seq=detail-fast10&orientation=portrait',
  'movie-suzume': 'https://readdy.ai/api/search-image?query=Suzume%20Japanese%20animated%20movie%20poster%20design%20cinematic%20film%20poster%20dark%20background%20professional%20artwork&width=600&height=900&seq=detail-suzume&orientation=portrait',
  'movie-manjianghong': 'https://readdy.ai/api/search-image?query=Full%20River%20Red%20Chinese%20historical%20comedy%20movie%20poster%20design%20cinematic%20film%20poster%20dark%20background%20professional%20artwork&width=600&height=900&seq=detail-manjianghong&orientation=portrait',
  'tv-threebody': 'https://readdy.ai/api/search-image?query=Three%20Body%20Chinese%20sci%20fi%20TV%20series%20poster%20design%20cinematic%20film%20poster%20dark%20background%20professional%20artwork&width=600&height=900&seq=detail-threebody&orientation=portrait',
  'movie-oppenheimer': 'https://readdy.ai/api/search-image?query=Oppenheimer%20historical%20drama%20movie%20poster%20design%20cinematic%20film%20poster%20dark%20background%20warm%20golden%20accents%20professional%20artwork&width=600&height=900&seq=detail-oppenheimer&orientation=portrait',
  'movie-demonslayer': 'https://readdy.ai/api/search-image?query=Demon%20Slayer%20Japanese%20animated%20movie%20poster%20design%20cinematic%20film%20poster%20dark%20background%20professional%20artwork&width=600&height=900&seq=detail-demonslayer&orientation=portrait',
};

const articleHeroImages: Record<string, string> = {
  'article-interstellar': 'https://readdy.ai/api/search-image?query=Interstellar%20movie%20scene%20black%20hole%20space%20cinematic%20dramatic%20lighting%20dark%20atmosphere%20film%20review%20header%20image%20warm%20golden%20tones&width=1200&height=500&seq=article-hero-interstellar&orientation=landscape',
  'article-kuangbiao': 'https://readdy.ai/api/search-image?query=The%20Knockout%20Chinese%20crime%20drama%20TV%20series%20scene%20dramatic%20lighting%20dark%20atmosphere%20film%20review%20header%20image%20warm%20toned%20cinematic&width=1200&height=500&seq=article-hero-kuangbiao&orientation=landscape',
  'article-nezha': 'https://readdy.ai/api/search-image?query=Nezha%20Chinese%20animated%20movie%20scene%20dramatic%20lighting%20dark%20atmosphere%20film%20review%20header%20image%20warm%20golden%20tones%20cinematic&width=1200&height=500&seq=article-hero-nezha&orientation=landscape',
  'article-zhenhuan': 'https://readdy.ai/api/search-image?query=Empresses%20in%20the%20Palace%20Chinese%20period%20drama%20scene%20elegant%20lighting%20imperial%20palace%20film%20review%20header%20image%20warm%20toned%20cinematic&width=1200&height=500&seq=article-hero-zhenhuan&orientation=landscape',
  'article-2024movies': 'https://readdy.ai/api/search-image?query=Chinese%20movie%20theater%20scene%20dramatic%20lighting%20dark%20atmosphere%20film%20preview%20header%20image%20warm%20golden%20tones%20cinematic%20upcoming%20films&width=1200&height=500&seq=article-hero-2024movies&orientation=landscape',
};

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const articleId = parseInt(id || '0', 10);

  const article = articles.find((a) => a.id === articleId);

  const movie = article?.movieId ? movies.find((m) => m.id === article.movieId) : null;

  if (!article) {
    return (
      <div className="min-h-screen bg-background-950">
        <Navbar />
        <main className="pt-24 px-4 md:px-6 flex flex-col items-center justify-center min-h-[60vh]">
          <i className="ri-error-warning-line text-5xl text-foreground-600 mb-4"></i>
          <h1 className="text-2xl font-bold text-white font-heading mb-2">文章未找到</h1>
          <p className="text-foreground-400 mb-6">抱歉，您要查看的内容不存在或已被移除。</p>
          <Link to="/" className="px-6 py-2.5 bg-primary-500 text-background-950 font-semibold text-sm rounded-full transition-all hover:bg-primary-600 whitespace-nowrap">
            返回首页
          </Link>
        </main>
        <Footer />
      </div>
    );
  }

  const relatedMovies = movie
    ? movies.filter((m) => m.category === movie.category && m.id !== movie.id).slice(0, 4)
    : [];

  const articleJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.summary,
    author: { '@type': 'Person', name: article.author },
    datePublished: article.date,
    ...(movie
      ? {
          about: {
            '@type': 'Movie',
            name: movie.title,
            dateCreated: movie.year,
            director: { '@type': 'Person', name: movie.director },
            actor: movie.actors.map((a) => ({ '@type': 'Person', name: a })),
          },
        }
      : {}),
  };

  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.nightowlcinema.com/' },
      { '@type': 'ListItem', position: 2, name: '影视详情', item: `https://www.nightowlcinema.com/article/${article.id}` },
    ],
  };

  const heroSrc = articleHeroImages[article.imageSeq] || articleHeroImages['article-interstellar'];
  const posterSrc = movie && detailPosterImages[movie.imageSeq]
    ? detailPosterImages[movie.imageSeq]
    : 'https://readdy.ai/api/search-image?query=generic%20movie%20poster%20design%20cinematic%20film%20poster%20dark%20background%20warm%20golden%20accents%20professional%20artwork&width=600&height=900&seq=detail-fallback&orientation=portrait';

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(articleJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbJsonLd) }}
      />
      <div className="min-h-screen bg-background-950">
        <Navbar />
        <main>
          <article>
            <header className="relative w-full h-[280px] md:h-[400px] overflow-hidden">
              <img
                src={heroSrc}
                alt={article.title}
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-background-950"></div>
              <div className="absolute inset-0 flex items-end pb-8 md:pb-12">
                <div className="w-full px-4 md:px-6">
                  <nav className="flex items-center gap-2 text-sm mb-4" aria-label="Breadcrumb">
                    <Link to="/" className="text-foreground-400 hover:text-primary-400 transition-colors">首页</Link>
                    <i className="ri-arrow-right-s-line text-foreground-500 text-xs"></i>
                    {movie && (
                      <>
                        <Link to={`/category/${movie.category}`} className="text-foreground-400 hover:text-primary-400 transition-colors">{movie.categoryName}</Link>
                        <i className="ri-arrow-right-s-line text-foreground-500 text-xs"></i>
                      </>
                    )}
                    <span className="text-primary-400">{article.title}</span>
                  </nav>
                  <h1 className="text-xl md:text-3xl font-bold text-white font-heading line-clamp-2">{article.title}</h1>
                  <div className="flex items-center gap-4 mt-3 text-sm text-foreground-400 flex-wrap">
                    <span className="flex items-center gap-1"><i className="ri-user-line"></i> {article.author}</span>
                    <span className="flex items-center gap-1"><i className="ri-calendar-line"></i> {article.date}</span>
                  </div>
                </div>
              </div>
            </header>

            {movie && (
              <section className="px-4 md:px-6 py-8">
                <div className="flex flex-col md:flex-row gap-6 md:gap-8">
                  <div className="flex-shrink-0 w-40 md:w-52 mx-auto md:mx-0">
                    <div className="aspect-[2/3] rounded-lg overflow-hidden bg-background-800">
                      <img
                        src={posterSrc}
                        alt={movie.title}
                        className="w-full h-full object-cover object-top"
                        title={`${movie.title} - 高清电影免费在线观看`}
                      />
                    </div>
                  </div>
                  <div className="flex-1">
                    <h2 className="text-lg md:text-xl font-bold text-white font-heading mb-4">{movie.title}</h2>
                    <div className="grid grid-cols-2 gap-x-6 gap-y-3 text-sm">
                      <div>
                        <span className="text-foreground-500">导演：</span>
                        <span className="text-foreground-300">{movie.director}</span>
                      </div>
                      <div>
                        <span className="text-foreground-500">年份：</span>
                        <span className="text-foreground-300">{movie.year}</span>
                      </div>
                      <div>
                        <span className="text-foreground-500">类型：</span>
                        <Link to={`/category/${movie.category}`} className="text-primary-400 hover:text-primary-300 transition-colors">{movie.categoryName}</Link>
                      </div>
                      <div>
                        <span className="text-foreground-500">时长：</span>
                        <span className="text-foreground-300">{movie.duration}</span>
                      </div>
                      <div>
                        <span className="text-foreground-500">评分：</span>
                        <span className="text-primary-400 font-semibold flex items-center gap-1">
                          <i className="ri-star-fill"></i> {movie.rating}
                        </span>
                      </div>
                    </div>
                    <div className="mt-4">
                      <span className="text-foreground-500 text-sm">主演：</span>
                      <div className="flex flex-wrap gap-2 mt-1">
                        {movie.actors.map((actor) => (
                          <span key={actor} className="px-3 py-1 bg-background-900 border border-background-700/50 rounded-full text-xs text-foreground-300">
                            {actor}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            )}

            <section className="px-4 md:px-6 py-6 md:py-10 max-w-3xl mx-auto">
              <div className="prose prose-invert prose-lg max-w-none">
                <h3 className="text-lg font-semibold text-white font-heading mb-4">内容简介</h3>
                {movie && (
                  <p className="text-foreground-300 leading-relaxed text-sm md:text-base">{movie.description}</p>
                )}
                <h3 className="text-lg font-semibold text-white font-heading mt-8 mb-4">详情介绍</h3>
                {article.content.split('\n').map((paragraph, idx) => (
                  <p key={idx} className="text-foreground-300 leading-relaxed mb-4 text-sm md:text-base">{paragraph}</p>
                ))}
              </div>
            </section>

            {relatedMovies.length > 0 && (
              <section className="px-4 md:px-6 py-8 md:py-12 bg-background-900/30">
                <h3 className="text-lg font-semibold text-white font-heading mb-6">相关推荐</h3>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
                  {relatedMovies.map((rm) => {
                    const relPoster = detailPosterImages[rm.imageSeq] || posterSrc;
                    return (
                      <Link
                        key={rm.id}
                        to={`/article/${articles.find(a => a.movieId === rm.id)?.id || rm.id}`}
                        className="group block"
                      >
                        <div className="relative aspect-[2/3] rounded-lg overflow-hidden mb-3 bg-background-800">
                          <img
                            src={relPoster}
                            alt={rm.title}
                            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                            title={rm.title}
                          />
                          <div className="absolute top-2 right-2 px-2 py-0.5 bg-black/70 rounded text-xs text-primary-400 font-semibold flex items-center gap-1">
                            <i className="ri-star-fill text-[10px]"></i> {rm.rating}
                          </div>
                        </div>
                        <h4 className="text-sm font-semibold text-white group-hover:text-primary-400 transition-colors line-clamp-1">{rm.title}</h4>
                        <p className="text-xs text-foreground-400 mt-1">{rm.year} · {rm.categoryName}</p>
                      </Link>
                    );
                  })}
                </div>
              </section>
            )}
          </article>
        </main>
        <Footer />
      </div>
    </>
  );
}